import { render, staticRenderFns } from "./TheoryQuestionsAdd.vue?vue&type=template&id=720ca36a&scoped=true&"
import script from "./TheoryQuestionsAdd.js?vue&type=script&lang=js&"
export * from "./TheoryQuestionsAdd.js?vue&type=script&lang=js&"
import style0 from "./TheoryQuestionsAdd.vue?vue&type=style&index=0&id=720ca36a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ca36a",
  null
  
)

export default component.exports